import {Component, Inject, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {DialogBaseComponent} from "../dialog-base/dialog-base.component";
import {FormControl, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatError, MatFormField, MatHint, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {NgForOf, NgIf} from "@angular/common";
import {MatButton} from "@angular/material/button";
import {IStripeRefundReason} from "../../../interfaces/IStripeRefundReason";
import {StripeRefundReasons} from "../../../consts/StripeRefundReasons";

@Component({
  selector: 'app-issue-refund-reason',
  standalone: true,
  imports: [
    DialogBaseComponent,
    MatError,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    NgForOf,
    NgIf,
    ReactiveFormsModule,
    MatButton
  ],
  templateUrl: './issue-refund-reason.component.html',
  styleUrl: './issue-refund-reason.component.css'
})
export class IssueRefundReasonDialogComponent {
  private dialogRef = inject(MatDialogRef<IssueRefundReasonDialogComponent>);

  public reasonControl = new FormControl<string>('', Validators.required);

  public validReasons: IStripeRefundReason[] = StripeRefundReasons;

  submit() {
    if (this.reasonControl.errors) {
      this.reasonControl.markAsTouched();
      return;
    }

    this.dialogRef.close({
      refundReason: this.reasonControl.value
    });
  }

  cancel() {
    this.dialogRef.close(false);
  }

  canContinue(): boolean {
    return this.reasonControl.valid;
  }
}



